import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { IData, defaultAutomaticTaskItem } from "../../../store/automatictask/automaticTaskItem";
import { Card, CardActions, CardContent, CardHeader, Grid, Typography } from "@material-ui/core";

import { Skeleton } from "@material-ui/lab";
import { FaciliteitInfo } from "../../molecules/views/FaciliteitInfo";
import { AfspraakVereist } from "../../molecules/views/AfspraakVereist";
import { useTranslation } from 'react-i18next';
import { IDetailOrganism } from "../IDetailOrganism";
import { AutomaticTaskIcon } from "../../atoms/icons/AutomaticTaskIcon";

// CSS
const useStyles = makeStyles((theme: Theme) => ({
    descriptionCard: {
        marginBottom: theme.spacing(2),
    }
}));

// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDetailOrganism<IData>;
export const AutomaticTaskDetail = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tAutomaticTask } = useTranslation('automatictask');
    const { t: tDatatypes } = useTranslation('datatypes');
    const { t: tCommon } = useTranslation('common');
    const data = props.data?.streamId ? props.data : defaultAutomaticTaskItem;
    
    // Utility function to check if a string has content (not null/undefined and not just whitespace)
    const hasContent = (value: string | null | undefined): boolean => {
        return value !== null && value !== undefined && value.trim() !== '';
    };
    
    // Helper function to safely get a string value (never null)
    const safeString = (value: string | null | undefined): string => {
        return value || '';
    };

    return (<Card>
        {props.loading ? 
            <CardHeader 
                title={<Skeleton variant="text" />} 
                subheader={<Skeleton variant="text" />} 
                avatar={<Skeleton variant="circle" />} 
            /> : 
            <CardHeader 
                title={tAutomaticTask('detailTitle', { title: data.title })} 
                subheader={`${data.completionPeriod || 0} dagen vanaf ${data.statusName || '-'}`} 
                avatar={<AutomaticTaskIcon />} 
            />
        }
        <CardContent>
            {hasContent(data.description) && (
                <Card className={classes.descriptionCard}>
                    <CardContent>
                        <Typography gutterBottom variant="h6" component="h3">
                            {safeString(data.title)}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p">
                            {props.loading ? <Skeleton variant="text" /> : safeString(data.description)}
                        </Typography>
                    </CardContent>
                </Card>
            )}

            <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>

                <Grid item xs={12} md={6} lg={6}>
                    <Typography gutterBottom variant="h5" component="h2">
                        {tAutomaticTask('instellingenTitle')}
                    </Typography>
                    
                    <AfspraakVereist loading={props.loading} label={tDatatypes('adminLabel')} value={data.forAdmin} />
                    <AfspraakVereist loading={props.loading} label={tDatatypes('verplichtLabel')} value={data.mandatory} />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                    <Typography gutterBottom variant="h5" component="h2">
                        Timing
                    </Typography>

                    <FaciliteitInfo loading={props.loading} label="Trigger status" value={safeString(data.statusName)} />
                    <FaciliteitInfo loading={props.loading} label={tDatatypes('aantalDagenLabel')} value={data.completionPeriod?.toString() || '0'} />
                </Grid>

            </Grid>
        </CardContent>
        <CardActions>
            {props.actions}
        </CardActions>
    </Card>)
}
